import SchoolIcon from '@mui/icons-material/School';
import PsychologyIcon from '@mui/icons-material/Psychology';
import * as React from 'react'

export default { SchoolIcon, PsychologyIcon, React }